export default{
    Mcount(state){
        state.count++;
    },
}